import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Register from './components/Register';
import SubmitCatch from './components/SubmitCatch';
import Leaderboard from './components/Leaderboard';
import Rules from './components/Rules';
import ResetPassword from './components/ResetPassword';
import Community from './components/Community';
import UserProfile from './components/UserProfile';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/submit" element={<SubmitCatch />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/community" element={<Community />} />
            <Route path="/user/:username" element={<UserProfile />} />
            <Route path="/rules" element={<Rules />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
